export enum Roles {
  ADMIN = 'ADMIN',
  DOCTOR = 'DOCTOR',
  PATIENT = 'PATIENT',
  NURSE = 'NURSE',
  SECRETARY = 'SECRETARY',
  CRMO = 'CRMO',
  HOSPITALIZATION = 'HOSPITALIZATION'
}
